export default __webpack_public_path__ + "static/media/question.daa76e4f.svg";